<template>

<div class="foot">

	<button class="foot-back" v-on:click="onBackClick" v-if="showBack"><span>Back</span></button>

	<button class="foot-proceed" v-on:click="onNextClick"><span>Next</span></button>

</div>

</template>

<script>

export default {

	props: ['section', 'custom', 'back'],

	computed: {

		// Only patients get the footer Back button, and only when there is a
		// real predecessor to go back to. The `back` prop lets a parent force
		// the state (e.g. the manual entry form mid-way through its steps).
		showBack: function() {

			if (!this.$isPatient) return false
			if (this.back === true) return true
			if (this.back === false) return false

			var current = this.$store.getters['session/section/current']
			var section = this.$_.findWhere(this.$store.getters['data/aid/sections/all'], { id: current })

			if (section && section.patient && section.patient.parent) return true

			var index = this.$_.findIndex(this.$store.getters['data/aid/sections/navigable'], { id: current })

			return index > 0

		}

	},

	methods: {

		onNextClick: function() {

			if (this.custom || this.$isPatient) {

				this.$emit('next')

			} else {

				this.$store.dispatch('proceed')

			}

		},

		onBackClick: function() {

			this.$emit('back')

		}

	}

}

</script>

<style scoped>

.foot {
	flex-shrink: 0;
	padding-top: 80px;
	display: flex;
	flex-direction: row;
	justify-content: center;
}

.is-mobile .foot {
	padding-top: 48px;
	padding-right: 24px;
}

.foot-back {
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background-color: #c9c9c9;
	margin-right: 32px;
	position: relative;
}

.foot-back:before {
	content: ' ';
	position: absolute;
	left: 0px;
	top: 0px;
	right: 0px;
	bottom: 0px;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-image: url(~@/assets/section.foot.chevron.svg);
	transform: rotate(180deg);
}

.foot-back:hover {
	filter: brightness(95%);
	transition: all 300ms ease-in-out;
}

.is-mobile .foot-back {
	width: 40px;
	height: 40px;
	margin-right: 20px;
}

.is-mobile .foot-back:before {
	background-size: 16px auto;
}

.foot-back span {
	text-transform: uppercase;
	color: #343434;
	font-size: 12px;
	line-height: 12px;
	letter-spacing: 1px;
	font-weight: 700;
	display: block;
	position: absolute;
	top: -24px;
	left: 0px;
	width: 64px;
	text-align: center;
}

.foot-proceed {
	width: 64px;
	height: 64px;
	border-radius: 50%;
	background-color: var(--primary-color);
	background-repeat: no-repeat;
	background-position: 50% 50%;
	background-image: url(~@/assets/section.foot.chevron.svg);
}

.is-aiding .foot-proceed {
	background-color: var(--aid-color);
}

.is-mobile .foot-proceed {
	width: 40px;
	height: 40px;
	background-size: 16px auto;
}

.foot-proceed:hover {
	filter: brightness(85%);
	transition: all 300ms ease-in-out;
}

.foot-proceed span {
	text-transform: uppercase;
	color: #343434;
	font-size: 12px;
	line-height: 12px;
	letter-spacing: 1px;
	font-weight: 700;
	display: block;
	position: absolute;
	top: -24px;
	width: 64px;
	text-align: center;
}

.is-mobile .foot-proceed span {
	margin-left: -12px;
}

</style>